import { Container } from "react-bootstrap";
import Component_1 from "../tabs_common_components/component_1/Component_1";
import Component_2 from "../tabs_common_components/component_2/Component_2";
import Component_3 from "../tabs_common_components/component_3/Component_3";
import Component_5 from "../tabs_common_components/component_5/Component_5";

const Kids_fitness = () => {
  const focusData = [
    {
      id: 1,
      icon: "/assets/images/sports-program/component-3/strength.png",
      title: "Strength",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus.",
    },
    {
      id: 2,
      icon: "/assets/images/sports-program/component-3/endurance.png",
      title: "Endurance",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus.",
    },
    {
      id: 3,
      icon: "/assets/images/sports-program/component-3/speed-agility.png",
      title: "Speed",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus.",
    },
    {
      id: 4,
      icon: "/assets/images/sports-program/component-3/flexibility.png",
      title: "Flexibility",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus.",
    },
    {
      id: 5,
      icon: "/assets/images/sports-program/component-3/core-stability.png",
      title: "Core Stability",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus.",
    },
    {
      id: 6,
      icon: "/assets/images/sports-program/component-3/fat-loss.png",
      title: "Fat Loss",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus.",
    },
    {
      id: 7,
      icon: "/assets/images/sports-program/component-3/body-toning.png",
      title: "Weight Gain",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus.",
    },
    {
      id: 8,
      icon: "/assets/images/sports-program/component-3/co-ordination.png",
      title: "Co-ordination",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus.",
    },
  ];
  return (
    <section className="kids-fitness-section">
      <Container>
        <Component_1
          topDescn={
            "Our Kids Fitness Program is designed to help children stay active, healthy, and confident through a perfect mix of fitness training and sports activities. We focus on overall development by combining fun, discipline, and structured coaching.Kids  fitness (Athletics kids Development program)is a sports program designed specifically for kids in the age group-3 to 15 yrs. Ashva sports creates a platform for education through sports to ensure practical implementation and fun learning. Different workout for all the 365 days"
          }
          title={"Training Structure"}
          features={[
            {
              label: "10 min:",
              value: "Warm-up & mobility exercises (10 min) ",
            },
            {
              label: "30 min :",
              value:
                "Fitness and strength training,Multiskill Activities 30 min,Athletics skill development,Speed & agility drills",
            },
            {
              label: "10 min:",
              value: "  games (10 min)",
            },
            {
              label: "10 min:",
              value: "  Cool down & stretching",
            },
          ]}
          imgSrc="./assets/images/sports-program/component-1/marathon.png"
        />

        <Component_5
          title={"Age Groups"}
          features={[
            "4–6 Years: Fun movement & basic coordination ",
            "7–10 Years: Fitness & athletics foundation",
            "11–15 Years: Advanced training & performance development",
          ]}
        />

        <Component_2
          title={"Weekly Training Components"}
          imgSrc="./assets/images/sports-program/component-2/run.png"
          features={[
            {
              label: "Runs:   ",
              value: "3–4 weekly runs focusing on endurance and form.",
              imgSrc: "./assets/images/sports-program/component-2/run.png",
            },
            {
              label: "Long Runs:  ",
              value:
                "One weekly long run that increases in distance each week. Run at a steady, comfortable pace.",
              imgSrc: "./assets/images/sports-program/component-2/long-run.png",
            },
            {
              label: "Easy Runs:",
              value:
                "Short, low-intensity runs for recovery and aerobic conditioning.",
              imgSrc: "./assets/images/sports-program/component-2/easy-run.png",
            },
            {
              label: "Speed Work:",
              value:
                "Includes tempo runs, intervals, and hill sprints to boost speed and stamina.",
              imgSrc:
                "./assets/images/sports-program/component-2/speed-work.png",
            },
            {
              label: "Cross-Training: ",
              value:
                " 1–2 low-impact sessions like swimming or cycling to build strength and reduce injury risk.",
              imgSrc:
                "./assets/images/sports-program/component-2/cross-training.png",
            },
            {
              label: "Strength Training:",
              value:
                " Focus on legs and core with exercises like squats, lunges, and deadlifts for better running power.",
              imgSrc: "./assets/images/sports-program/component-2/strength.png",
            },
            {
              label: "Rest:",
              value:
                "Rest is essential for muscle recovery and injury prevention — never skip it.",
              imgSrc: "./assets/images/sports-program/component-2/rest.png",
            },
          ]}
        />

        <Component_5
          title={"Program Benefits"}
          features={[
            "⁠strength ",
            "Speed",
            "Flexibility",
            "Endurance",
            "body and mind coordination ",
            "Improves overall fitness and stamina",
            "Enhances coordination and motor skills",
            "Builds confidence and discipline",
          ]}
        />

        <Component_3 focusData={focusData} showTitle={false} />
      </Container>
    </section>
  );
};

export default Kids_fitness;
